import { Text, View } from "@react-pdf/renderer";
function Desription({ vehicles }) {
  const vehicleText = (vehicle, index) => {
    return (
      <Text style={{ padding: "2px" }} key={vehicle.vin}>
        {index}. VIN:{vehicle.vin}, Year: {vehicle.year}, Make: {vehicle.make},
        Model: {vehicle.model}, Value:{" "}
        {new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
        }).format(vehicle.value)}
      </Text>
    );
  };

  return (
    <View
      style={{
        borderLeft: "1.5px solid black",
        borderRight: "1.5px solid black",
        borderBottom: "1.5px solid black",
        width: "95%",
        fontSize: "7.5px",
      }}
    >
      <Text style={{ fontFamily: "Helvetica-Bold", padding: "2px" }}>
        DESCRIPTION OF OPERATIONS / LOCATIONS / VEHICLES / (Attach ACORD 101,
        Additional Remarks Schedule, if more space is required)
      </Text>
      {vehicles?.length > 0 &&
        vehicles.map((vehicle, index) => vehicleText(vehicle, index + 1))}
    </View>
  );
}
export default Desription;
